import { render, staticRenderFns } from "./LiquidacionGrupoCochada.vue?vue&type=template&id=0fbffc53"
import script from "./LiquidacionGrupoCochada.vue?vue&type=script&lang=js"
export * from "./LiquidacionGrupoCochada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports